import styled from 'styled-components';
import { rgba } from 'polished';
import { Icon } from '@cld/icon';
import { combineValues } from '@cld/component-theme';
import { theme } from './theme';
import { SpacingType, getCssPadding } from './spacing';

export const Label = styled.summary`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;
  padding: ${theme.padding.vertical} ${theme.padding.horizontal};

  :focus {
    outline: none;
    box-shadow: ${theme.focus.boxShadow.sizes} ${combineValues(theme.focus.boxShadow.baseColor, (color) => rgba(color, 0.5))},
      inset 0 0 0 1px ${theme.focus.boxShadow.baseColor};
  }

  &::-webkit-details-marker {
    display: none;
  }
`;

export const Content = styled.div<{ verticalPadding?: SpacingType, horizontalPadding?: SpacingType }>`
  padding:
    ${({ verticalPadding }) => getCssPadding('vertical', verticalPadding)}
    ${({ horizontalPadding }) => getCssPadding('horizontal', horizontalPadding)};
`;

export const Root = styled.details`
  ${Icon} {
    transition: 0.25s;
  }

  &[open] ${Label} ${Icon} {
    transform: rotate(180deg);
  }
`;
